import React from 'react';
import { Checkbox, Text } from '@chakra-ui/react';
import { usePropagacaoHabilitada } from '../../hooks/usePropagacaoHabilitada';

export const TEXTO_PROPAGACAO =
  'Aplicar também às questões já vinculadas em questionários existentes';

/**
 * EG-41 — CA07.1/CA08: o checkbox de propagação.
 *
 * Existe como componente próprio por dois motivos.
 *
 * O texto é literal do CA07.1 e aparece no modal de edição e na classificação
 * em massa. Duas cópias divergiriam no primeiro ajuste.
 *
 * A borda visível NÃO mora mais aqui: virou baseStyle de Checkbox no tema
 * (V5), porque a caixa invisível atingia o painel inteiro e não só esta tela.
 *
 * EG-42 — AD-11: com a chave da propagação desligada, ele não se renderiza.
 *
 * A verificação mora AQUI e não nos dois modais de propósito — foi o que a AD-11
 * pediu ao chamar isto de ponto único: some nos dois consumidores de uma vez, e
 * um terceiro consumidor futuro herda a regra sem que ninguém lembre dela.
 *
 * Esconder é UX. A proteção que importa é a guarda do backend (AD-10), que
 * recusa a propagação com 409 — são duas camadas independentes, e a ausência do
 * checkbox não é o que impede a propagação de rodar.
 */

const CheckboxPropagacao = ({ isChecked, onChange, size = 'md' }) => {
  const propagacaoHabilitada = usePropagacaoHabilitada();

  if (!propagacaoHabilitada) return null;

  return (
    <Checkbox
      size={size}
      isChecked={isChecked}
      onChange={(evento) => onChange(evento.target.checked)}
      iconColor='white'
    >
      <Text as='span' fontSize='sm'>
        {TEXTO_PROPAGACAO}
      </Text>
    </Checkbox>
  );
};

export default CheckboxPropagacao;
